<template>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Jantina'" >
        <GChart :type="type_pie" :data="jantina_datas"   :options="pie_options"  v-if="jantina_datas.length > 0"/>
      </z-page>
    </div>
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Jantan'" >
        <GChart :type="type_pie" :data="jantan_datas"   :options="pie_options"  v-if="betina_datas.length > 0"/>
      </z-page>
    </div>
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Betina'" >
        <GChart :type="type_pie" :data="betina_datas"   :options="pie_options"  v-if="betina_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka Insemination'" >
        <GChart :type="type_column" :data="baka_insemination_datas"   :options="column_options"  v-if="baka_insemination_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka Ternakan'" >
        <GChart :type="type_pie" :data="baka_ternakan_datas"   :options="pie_2_options"  v-if="baka_ternakan_datas.length > 0"/>
      </z-page>
    </div>
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka '" >
        <GChart :type="type_pie" :data="baka_datas"   :options="pie_2_options"  v-if="baka_datas.length > 0"/>
      </z-page>
    </div>
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Vaksin Ternakan'" >
        <GChart :type="type_pie" :data="vaksin_datas"   :options="pie_2_options"  v-if="vaksin_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka Jantina'" >
        <GChart :type="type_column" :data="baka_jantina_datas"   :options="column_options"  v-if="baka_jantina_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Stock Vaksin'" >
        <GChart :type="type_column" :data="stok_vaksin_datas"   :options="pie_2_options"  v-if="stok_vaksin_datas.length > 0"/>
      </z-page>
    </div>
    
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "Pentadbir",
  components: {
        GChart
  },
  data() {
    return {
      loading: false,
      type_pie: "PieChart",
      type_column: "ColumnChart", 
      pie_options: {
          height: 200,
      },
      pie_2_options: {
          height: 250,
      },
      column_options: {
          height: 500,
      },
      jantina_datas: [],
      jantan_datas: [],
      betina_datas: [],
      baka_ternakan_datas: [],
      baka_datas: [],
      baka_jantina_datas: [],
      baka_insemination_datas: [],
      vaksin_datas: [],
      stok_vaksin_datas: [],  
    }  
  },
  methods:{
    getJantina(){
      this.$zcomm.get(this.api_service + 'dashboard/jantina', {}).then(res => {
        this.jantina_datas = res
      })
    },
    getJantan(){
      this.$zcomm.get(this.api_service + 'dashboard/jantan', {}).then(res => {
        this.jantan_datas = res
      })
    },
    getBetina(){
      this.$zcomm.get(this.api_service + 'dashboard/betina', {}).then(res => {
        this.betina_datas = res
      })
    },
    getBakaTernakan(){
      this.$zcomm.get(this.api_service + 'dashboard/baka_ternakan', {}).then(res => {
        this.baka_ternakan_datas = res
      })
    },
    getBakaJantan(){
      this.$zcomm.get(this.api_service + 'dashboard/baka', {}).then(res => {
        this.baka_datas = res
      })
    },
    getBakaJantina(){
      this.$zcomm.get(this.api_service + 'dashboard/baka_jantina', {}).then(res => {
        this.baka_jantina_datas = res
      })
    },
    getBakaInsemination(){
      this.$zcomm.get(this.api_service + 'dashboard/baka_insemination', {}).then(res => {
        this.baka_insemination_datas = res
      })
    },
    getVaksin(){
      this.$zcomm.get(this.api_service + 'dashboard/vaksin', {}).then(res => {
        this.vaksin_datas = res
      })
    },
    getStokVaksin(){
      this.$zcomm.get(this.api_service + 'dashboard/stok_vaksin', {}).then(res => {
        this.stok_vaksin_datas = res
      })
    }
  },
      
  mounted() {
    this.getJantina()
    this.getJantan()
    this.getBetina()
    this.getBakaTernakan()
    this.getBakaJantan()
    this.getBakaJantina()
    this.getBakaInsemination()
    this.getStokVaksin()
    this.getVaksin()
  }
}
      

</script>  
